import { render } from "./ChapterRail.vue?vue&type=template&id=daf588da&scoped=true"
import script from "./ChapterRail.vue?vue&type=script&lang=js"
export * from "./ChapterRail.vue?vue&type=script&lang=js"

import "./ChapterRail.vue?vue&type=style&index=0&id=daf588da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-daf588da"]])

export default __exports__